import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../ui/Logo';
import Icon from '../ui/Icons';
import COMPANY, { ROUTES } from '../../config/company';

const COLS = [
  {
    title: 'Rentals',
    links: [
      ['Dry van trailers', `${ROUTES.trailers}#dry-van`],
      ['Reefer trailers', `${ROUTES.trailers}#reefer`],
      ['Flatbed trailers', `${ROUTES.trailers}#flatbed`],
      ['Carrier sign-up', ROUTES.signup],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Bitnex Freight LLC', ROUTES.about],
      ['Contact us', ROUTES.contact],
      ['SMS updates (opt-in)', ROUTES.smsOptIn],
      
    ],
  },
  {
    title: 'Legal',
    links: [
      ['Privacy Policy', ROUTES.privacy],
      ['Terms & Conditions', ROUTES.terms],
      ['SMS terms', ROUTES.smsTerms],
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="texture-dark relative bg-navy-900 text-navy-100">
      <div className="diagonal-stripe h-2 w-full" aria-hidden="true" />
      <div className="shell py-16 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div className="max-w-sm">
            <Link to={ROUTES.home} className="inline-block">
              <Logo inverse />
            </Link>
            <p className="mt-5 font-display text-2xl font-bold text-white">{COMPANY.tagline}</p>
            <p className="mt-3 text-[0.92rem] leading-relaxed text-navy-200">
              DOT-inspected dry van, reefer and flatbed trailers for carriers and owner-operators. Flexible
              terms, transparent pricing, pickup when you need it.
            </p>
          </div>

          {COLS.map((col) => (
            <div key={col.title}>
              <h3 className="mb-4 text-[0.72rem] font-bold uppercase tracking-[0.2em] text-gold-300">
                {col.title}
              </h3>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-[0.92rem] text-navy-100 transition-colors hover:text-white">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 grid gap-6 border-t border-white/10 pt-8 text-[0.9rem] sm:grid-cols-2 lg:grid-cols-3">
          {COMPANY.phone && <div>
            <h3 className="mb-2 text-[0.72rem] font-bold uppercase tracking-[0.2em] text-gold-300">Phone</h3>
            <a href={COMPANY.phone} className="font-semibold text-white hover:text-gold-300">
              {COMPANY.phoneDisplay}
            </a>
          </div>}
          <div>
            <h3 className="mb-2 text-[0.72rem] font-bold uppercase tracking-[0.2em] text-gold-300">Email</h3>
            <a href={COMPANY.email} className="font-semibold text-white hover:text-gold-300">
              {COMPANY.emailDisplay}
            </a>
          </div>
          <div>
            <h3 className="mb-2 text-[0.72rem] font-bold uppercase tracking-[0.2em] text-gold-300">
              {COMPANY.hq.label}
            </h3>
            <p className="text-navy-100">
              {COMPANY.legalName}<br />
              {COMPANY.hq.line1}
              <br />
              {COMPANY.hq.line2}
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="max-w-5xl text-[0.78rem] leading-relaxed text-navy-200">
            <strong className="text-navy-100">SMS disclosure:</strong> {COMPANY.legalName} sends text messages only to customers who opt in on our
            website. Customer care texts (reservation confirmations, pickup and return reminders, account and billing notifications, customer-care replies)
            and marketing texts (trailer availability, specials and offers) are consented to separately; you are opting in to marketing texts only if you check
            the marketing box. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out at any time; reply HELP for help, call {COMPANY.phoneDisplay}, or email {COMPANY.emailDisplay}. Consent is not a condition of purchase. Your mobile phone number and SMS opt-in consent will not be sold or
            shared with third parties or affiliates for marketing or promotional purposes. See our{' '}
            <Link to={ROUTES.privacy} className="underline hover:text-white">
              Privacy Policy
            </Link>
            ,{' '}
            <Link to={ROUTES.terms} className="underline hover:text-white">
              Terms &amp; Conditions
            </Link>{' '}
            and{' '}
            <Link to={ROUTES.smsTerms} className="underline hover:text-white">
              SMS Terms
            </Link>
            .
          </p>
          <div className="mt-6 flex flex-col gap-3 text-[0.8rem] text-navy-300 sm:flex-row sm:items-center sm:justify-between">
            <p>
              © {year} {COMPANY.brand}. All rights reserved. Business identity: {COMPANY.legalName}.
            </p>
            <p className="inline-flex items-center gap-1.5">
              <Icon name="shield" className="h-3.5 w-3.5 text-gold-300" /> DOT-inspected equipment · Licensed &amp;
              insured
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
